import React from "react";
import { useLocalStorage } from "@uidotdev/usehooks";

import { Organization } from "@/components/common/OrganizationSwitcher/types";

import { UiUtils } from "@/utils/ui";

export function useCmdHotKey({
  shouldUseCmd,
  setIsOpen,
}: {
  shouldUseCmd: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const fn = React.useMemo(
    () => (shouldUseCmd ? () => {} : () => setIsOpen((o) => !o)),
    [setIsOpen, shouldUseCmd],
  );
  React.useEffect(() => {
    return UiUtils.cmdHotKeyElement("#organization-switcher-trigger", fn);
  }, [fn, setIsOpen]);
}

export function useSelectedOrganization() {
  return useLocalStorage<Organization | undefined>(
    "selected_organization",
    undefined,
  );
}
